import { Device } from '@hc-frontend/core-types';

const { DESKTOP, MOBILE, TABLET } = Device.Enum;

export const DeviceCatalog: Record<string, Device> = {
  m: MOBILE,
  p: MOBILE,
  t: TABLET,
  c: DESKTOP,
  tablet: TABLET,
  mobile: MOBILE,
  computer: DESKTOP,
  desktop: DESKTOP,
};

export function ivDeviceToDevice(ivDevice: string): Device | undefined {
  return DeviceCatalog[ivDevice];
}
